module.exports = __webpack_public_path__ + "img/icon_arrow_down@3x.2770ab21.png";